import TourTooltip from 'elements/tooltip/TourTooltip'
import { TourConfigType } from 'persistentContent/tours/types'
import { useTranslate } from 'ra-core'
import { FC } from 'react'

const StepTooltip: FC = (props) => {
  const translate = useTranslate()
  return (
    <TourTooltip
      title={translate('Meet Ada')}
      subtext={translate(
        'Ada is your AI assistant in OpenSolar. You can ask questions, get help with design, navigate the app, and much more.'
      )}
      {...props}
    />
  )
}

const ChatHeader: TourConfigType = {
  spotlights: [{ targetId: 'Ada-Chat-Header', autoScroll: true }],
  tooltips: [
    {
      targetId: 'Ada-Chat-Header',
      placement: 'right',
      component: StepTooltip,
      options: { style: { marginLeft: 10 } },
    },
  ],
}

export default ChatHeader
